<template>
  <div>
    <h2
      :id="titleId"
      class="bmn contrast"
    >
      {{ title }}
    </h2>
    <div>
      <v-client-table
        :ref="titleId"
        :name="titleId"
        :data="documentTable"
        :columns="columns"
        :options="options"
      >
        <a
          :id="row.id"
          slot="Organization"
          slot-scope="{row}"
          :href="row.Web"
          target="_blank"
          :class="{ external: !row.Web.includes('phila.gov') }"
        ><span class="title">{{ row.Organization }}</span></a>
        <div slot="afterFilter">
          <span><i class="fas fa-search fa-2x" /></span>
        </div>
      </v-client-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteFinder',
  props: {
    documentTable: {
      type: Array,
      default: () => {
        return [];
      },
    },
    query: {
      type: String,
      default: () => {
        return null;
      },
    },
    titleHash: {
      type: String,
      default: () => {
        return null;
      },
    },
    title: {
      type: String,
      default: () => {
        return null;
      },
    },
  },
  data: function() {
    return {
      columns: [ 'Area', 'Scope Boundaries', 'Organization' ],
      options: {
        texts: {
          filterPlaceholder: "Begin typing to filter by area, scope boundary or organization",
        },
        perPage: 400,
        perPageValues: [],
      },
      titleId: this.titleHash.split(' ').join('-').toLowerCase(),
    };
  },
};
</script>